import React from 'react';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var jewelry = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "15",
    viewBox: "0 0 16 15"
  }, props), React.createElement("path", {
    d: "M2.211.686L2.2.706.167 3.956h3.308zM4.53 3.45L7.429.091H3.231l.007.018L4.53 3.45zM12.762.109l.007-.018H8.572l2.897 3.36L12.762.108zm3.071 3.846L13.8.707l-.012-.02-1.266 3.268zM11 5.172L8 8.924 5 5.172H.086L7.23 13.71l.4.478a.486.486 0 0 0 .37.172.485.485 0 0 0 .368-.172l.4-.479 7.146-8.538H11z"
  }), React.createElement("path", {
    d: "M8 6.96l2.366-3.005L8 1.212 5.634 3.955z"
  }));
});

export default jewelry;
//# sourceMappingURL=jewelry.svg.js.map
